class IntroSection {
    constructor() {
        this.createIntroHTML()
    }

    createIntroHTML() {
        // Create intro section container
        const introSection = document.createElement('div')
        introSection.className = 'intro-section'
        introSection.id = 'intro'

        // Create the panel (card)
        const panel = document.createElement('div')
        panel.className = 'intro-panel'

        // Left column - Title
        const titleBlock = document.createElement('div')
        titleBlock.className = 'intro-title'
        titleBlock.innerHTML = `Bonjour, je suis Maxence,<br>graphiste & designer`

        // Right column - Description
        const descBlock = document.createElement('div')
        descBlock.className = 'intro-description'
        descBlock.textContent = 'Je suis aujourd\'hui graphiste freelance. Découvrez mes travaux les plus récents.'

        // Append columns to panel
        panel.appendChild(titleBlock)
        panel.appendChild(descBlock)

        // Append panel to section
        introSection.appendChild(panel)

        // Add to content wrapper (will be created in HTML)
        const contentWrapper = document.querySelector('.content-wrapper') || document.body
        contentWrapper.appendChild(introSection)

        this.section = introSection
        this.setupScrollAnimation()
    }

    setupScrollAnimation() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // Ajouter un délai avant de déclencher l'animation
                    setTimeout(() => {
                        entry.target.classList.add('visible')
                    }, 800)
                }
            })
        }, {
            threshold: 0.8
        })

        const panel = this.section.querySelector('.intro-panel')
        observer.observe(panel)
    }

    // No longer needed but keep for compatibility
    updateVisibility(scrollY) {
        // Empty - section is always visible now
    }
}

export default IntroSection
